import { render, staticRenderFns } from "./resend-postbacks.vue?vue&type=template&id=7efd94a2&scoped=true&"
import script from "./resend-postbacks.vue?vue&type=script&lang=ts&"
export * from "./resend-postbacks.vue?vue&type=script&lang=ts&"
import style0 from "./resend-postbacks.vue?vue&type=style&index=0&id=7efd94a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efd94a2",
  null
  
)

export default component.exports